import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import FeedDefault from './Default';
import FeedPlayful from './Playful';

function Feed(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const isPlayfulTeacherTheme = usePlayfulTeacher();
  const isPlayfulTheme = isPlayfulStudentTheme || isPlayfulTeacherTheme;
  return isPlayfulTheme ? <FeedPlayful {...props} /> : <FeedDefault {...props} />;
}

export { Feed };
export * from './feed-post';
